import { createFeatureSelector } from '@ngrx/store';

import { COMMON_BOOKING_FEATURE_KEY } from '../constants';
import { CommonBookingState } from '../store.interface';

export const selectCommonBookingState = createFeatureSelector<CommonBookingState>(COMMON_BOOKING_FEATURE_KEY);
